export enum JobStatut {
    Actif = 'Actif',
    EnPause = 'EnPause',
    EnCours = 'EnCours',
    Erreur = 'Erreur'
}
